/* 🤖 this file was generated by script */
export const wiconEdit03 = {
  name: 'edit_03',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 20h9M3 20h1.67c.5 0 .74 0 .97-.06a2 2 0 00.58-.23c.2-.13.37-.3.72-.65L19.5 6.5a2.12 2.12 0 10-3-3L3.94 16.06c-.35.35-.52.52-.65.72a2 2 0 00-.23.58c-.06.23-.06.48-.06.97V20z"/></svg>`,
};
